import React, { useEffect, useState } from "react";
import { CommonListType, useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import Location from "../../../../models/Location";
import {
	getDetailDestinations,
	getListDestinations,
	getRecommendLocation,
	getTopDestinations,
	offlineGetDetailDestination,
} from "../../../../services/LocationService";
import { withSsrRawDataMulti } from "../../../controls/common/StaticContextWrap";
import useStaticContext from "../../../hooks/useStaticContext";
import { EmailTemplateData, getEmailContent, getEmailKeywork, listEmailVersions } from "../../../../services/EmailSerivce";
import { ensureSimpleEmailFooterBlock, getSimpleEmailStarter } from "../simpleEmailTemplate";

export default function useEmailContent(props: { id: number; openDialog?: boolean }) {
	const [content, setContent] = useState<string>();
	const loadEmaiContent = async () => {
		try {
			// Prefer the latest unpublished draft so "Lưu nháp" survives a reload.
			try {
				const versions = await listEmailVersions(props.id);
				const byNewest = (a: { createdAt: string }, b: { createdAt: string }) =>
					a.createdAt < b.createdAt ? 1 : -1;
				const latestDraft = versions.filter((v) => v.status === "draft").sort(byNewest)[0];
				const latestPublished = versions.filter((v) => v.status === "published").sort(byNewest)[0];
				const draftContent = (latestDraft?.content || "").trim();
				if (
					latestDraft &&
					draftContent &&
					(!latestPublished || latestDraft.createdAt >= latestPublished.createdAt)
				) {
					setContent(ensureSimpleEmailFooterBlock(latestDraft.content));
					return;
				}
			} catch {
				// versions unavailable — fall back to published content below
			}
			let prods = await getEmailContent(props.id);
			const dbContent = (prods.data || "").trim();
			if (dbContent) {
				setContent(ensureSimpleEmailFooterBlock(prods.data));
			} else {
				setContent(getSimpleEmailStarter(props.id));
			}
		} catch (error) {
			console.error(error);
			setContent(getSimpleEmailStarter(props.id));
		}
	};
	const reload = () => {
		loadEmaiContent();
	};
	useEffect(() => {
		if (props.id && props.openDialog) {
			reload();
		}
	}, [props.id, props.openDialog]);
	return {
		content,
		setContent,
		reload,
	};
}
